import {hasNucleotideInput} from 'search/blast/BLASTUtil';
import * as FileExtractionDAO from 'search/blast/FileExtractionDAO';
import {BLASTOperator} from 'search/SearchConstants';
import * as ImportUtil from 'util/ImportUtil';

import ExtractedQuerySequence from './ExtractedQuerySequence';

export async function extractBLASTQuerySequencesFromFiles(
  operator: BLASTOperator,
  files: Array<File>
): Promise<Array<ExtractedQuerySequence>> {
  const s3Locations = await Promise.all(files.map((file) => ImportUtil.upload(file)));
  const validS3Locations = s3Locations.filter((l) => l) as Array<string>;

  if (hasNucleotideInput(operator)) {
    const extractedSequences = await FileExtractionDAO.extractSequences(validS3Locations);
    return extractedSequences.filter((es) => es.sequence.length > 0);
  } else {
    const extractedSequences = await FileExtractionDAO.extractAaSequences(validS3Locations);
    return extractedSequences.filter((es) => es.sequence.length > 0);
  }
}
